module.exports = __webpack_public_path__ + "static/media/directorsIcon.f4804cbb.svg";